import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import TimeInput from "react-time-picker-input";
import { diasOptions } from "../utils/utils";
import moment from "moment";

const { Select2, Date, DateTime, Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];
function AddSeguro({ history, match }) {
  const dispatch = useDispatch();

  const modelAddSeguro = useSelector((state) => state.addSeguro);

  const [nombre, setNombre] = useState(null);
  const [estado, setEstado] = useState("ACTIVO");
  const [localId, setLocalId] = useState(
    match.params.localId ? match.params.localId : null
  );

  useEffect(() => {
    const data = modelAddSeguro?.data?.data;
    const error = modelAddSeguro?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckAddSeguro.actions.clear());
    }
    if (data) {
      history.push(
        !match.params.localId ? "/locales" : `/seguros/${match.params.localId}`
      );
      dispatch(controller.duckAddSeguro.actions.clear());
    }
  }, [modelAddSeguro]);

  function submit() {
    if (!nombre || !estado) {
      alert("Por favor complete todos los campos");
      return;
    }

    if (!localId) {
      alert("No se ha podido obtener el ID del local");
      return;
    }

    let data = {
      nombre,
      estado,
      localId,
    };

    dispatch(controller.cargarSeguroThunk(data));
  }

  return (
    <Content title="Nuevo seguro" browserTitle="Nuevo seguro" show={false}>
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Nuevo seguro"
            footer={
              <>
                <Button text="Cancelar" onClick={() => history.goBack()} />

                <Button
                  type="primary"
                  text="Guardar"
                  pullRight={true}
                  disabled={modelAddSeguro.loading}
                  onClick={() => submit()}
                />
              </>
            }
          >
            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={estadoOptions()}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Nombre"
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AddSeguro;
